module.exports = __webpack_public_path__ + "static/media/ecosentino.4ab24013.svg";